import { Component } from '@angular/core';

@Component({
    selector: 'app-loader',
    templateUrl: './weave-loader.component.html',
    styleUrls: ['./weave-loader.component.scss'],
    standalone: false
})
export class WeaveLoaderComponent {

  constructor() { }

}
